import Heading from './Heading';
import OtherCities from './Othercities';

const Home = () => (
  <div>
    <Heading />
    <OtherCities />
  </div>
);

export default Home;
